import Cookies from 'js-cookie';

export const isCookieSet = (cookieKey: string, cookieValue: string) => {
  const value = Cookies.get(cookieKey);

  return Boolean(value && value === cookieValue);
};
